export default "__VITE_ASSET__DYehjVlF__"